module.exports = __webpack_public_path__ + "static/media/135_ExteriorWhiteHall.e2b03bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135_ExteriorWhiteHall.jpg
// module id = 116
// module chunks = 0